var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.footer",
  title: "Universe Footer",
  description: "Shared Universe footer with server-renderable legal and banner content.",
  supportServer: true,
  fields: {
    version: { title: "Version", type: "number", description: "Footer schema version." },
    banner: { title: "Banner", type: "object", description: "Footer banner content." },
    app: { title: "App", type: "object", description: "App footer content options." },
    appLinks: { title: "App Links", type: "list", description: "Optional app footer links." },
    promo: { title: "Promo", type: "object", description: "Optional promo band." },
    legal: { title: "Legal", type: "object", description: "Legal footer settings." },
    on: { title: "Dates", type: "object", description: "Footer lifecycle dates." }
  }
});

function text(value, fallback) {
  if (value === undefined || value === null || value === "") return fallback || "";
  return String(value);
}

function trimSlash(url) {
  var out = text(url, "").trim();
  return out.replace(/\/+$/, "");
}

function yearFromDates(on) {
  var value = text(on && (on.published || on.modified || on.created), "");
  if (/^\d{4}/.test(value)) return value.slice(0, 4);
  var date = new Date(value);
  if (!isNaN(date.getTime())) return String(date.getUTCFullYear());
  return String(new Date().getUTCFullYear());
}

exports.render = async function(options) {
  var banner = options.banner || {};
  var app = options.app || {};
  var promo = options.promo || {};
  var legal = options.legal || {};
  var appLinks = Array.isArray(options.appLinks) ? options.appLinks : [];

  var homeUrl = trimSlash(legal.homeUrl || "https://egtuniverse.com") + "/";
  var termsUrl = text(legal.termsUrl, trimSlash(homeUrl) + "/legal");
  var privacyUrl = text(legal.privacyUrl, trimSlash(homeUrl) + "/legal/privacy");
  var logoUrl = text(legal.logoUrl, trimSlash(homeUrl) + "/logo.svg");
  var companyShortName = text(legal.companyShortName, "EGT");
  var isLocked = legal.locked !== false;
  var showApp = app.visible === true;
  var showPromo = promo && promo.enabled === true && promo.href;

  return {
    n: "footer",
    c: "text-center text-lg-start bg-50-info text-muted tiny-outline",
    "data-ua-footer": "shared",
    i: [
      {
        n: "section",
        c: "bg-75-info p-4 border-bottom",
        "aria-labelledby": "ua-footer-banner-title",
        i: {
          n: "div",
          c: "container text-center",
          i: [
            { n: "p", c: "text-uppercase small fw-semibold text-primary mb-1", i: text(banner.eyebrow, "Welcome to The Universe,") },
            { n: "h2", id: "ua-footer-banner-title", c: "h5 slug-line mb-0", i: text(banner.message, "pursue your dreams!") }
          ]
        }
      },
      showPromo ? {
        n: "section",
        c: "p-4 border-bottom",
        i: {
          n: "div",
          c: "container text-center",
          i: {
            n: "a",
            href: promo.href,
            c: "text-reset text-decoration-none",
            i: [text(promo.beforeText, ""), text((promo.typeonWords || []).join(" "), ""), text(promo.afterText, "")].filter(Boolean).join(" ")
          }
        }
      } : "",
      {
        n: "section",
        c: showApp ? "" : "d-none",
        "aria-label": "App footer content",
        i: {
          n: "div",
          c: "container mt-5",
          i: {
            n: "div",
            c: "row mt-3 justify-content-center g-3",
            i: appLinks.map(function(link) {
              return {
                n: "div",
                c: "col-12 col-md-6 col-lg-4",
                i: {
                  n: "a",
                  href: link && (link.href || link.url || "#"),
                  c: "text-reset text-decoration-none",
                  i: text(link && (link.label || link.title), "Learn more")
                }
              };
            })
          }
        }
      },
      {
        n: "div",
        c: "p-4 bg-black border-top",
        "data-ua-footer-legal": isLocked ? "locked" : "open",
        i: {
          n: "div",
          c: "container",
          i: {
            n: "div",
            c: "d-flex flex-column align-items-center gap-3 text-center",
            i: [
              {
                n: "a",
                href: homeUrl,
                c: "text-reset d-inline-flex align-items-center justify-content-center",
                i: {
                  n: "img",
                  src: logoUrl,
                  c: "img-fluid",
                  style: "width:4rem; max-width:100%; height:auto;",
                  alt: "The Universe Logo"
                }
              },
              { n: "p", c: "mb-0 small", i: "&copy; " + yearFromDates(options.on) + ". " + companyShortName + ". All Rights Reserved." },
              {
                n: "nav",
                "aria-label": isLocked ? "Locked Universe legal strip" : "Universe legal strip",
                i: {
                  n: "ul",
                  c: "list-inline mb-0 small d-flex flex-wrap justify-content-center gap-3",
                  i: [
                    { n: "li", c: "list-inline-item mb-0", i: { n: "a", href: termsUrl, c: "text-reset", i: "Terms of Service" } },
                    { n: "li", c: "list-inline-item mb-0", i: { n: "a", href: privacyUrl, c: "text-reset", i: "Privacy Policy" } }
                  ]
                }
              }
            ]
          }
        }
      }
    ].filter(Boolean)
  };
};
